export enum WithdrawalBeneficiaryDetailTypeEnum {
    BENEFICIARY = 'bene',
    BENEFICIARY_BANK = 'benebank',
    INTERMEDIARY_BANK = 'intbank',
    ADDITIONAL_INFO = 'adtlinfo',
    BLOCKCHAIN = 'blockchain'
}

type WithdrawalBeneficiaryDetailTypeMap = Record<
    keyof typeof WithdrawalBeneficiaryDetailTypeEnum,
    {
        keyName: string;
        value: string;
        displayValue: string;
    }
>;

export const WithdrawalBeneficiaryDetailTypeMap: WithdrawalBeneficiaryDetailTypeMap = {
    BENEFICIARY: {
        keyName: 'BENEFICIARY',
        value: 'bene',
        displayValue: 'Beneficiary Information'
    },
    BENEFICIARY_BANK: {
        keyName: 'BENEFICIARY_BANK',
        value: 'benebank',
        displayValue: 'Beneficiary Bank Information'
    },
    INTERMEDIARY_BANK: {
        keyName: 'INTERMEDIARY_BANK',
        value: 'intbank',
        displayValue: 'Intermediary Bank Information'
    },
    ADDITIONAL_INFO: {
        keyName: 'ADDITIONAL_INFO',
        value: 'adtlinfo',
        displayValue: 'Additional Information'
    },
    BLOCKCHAIN: {
        keyName: 'BLOCKCHAIN',
        value: 'blockchain',
        displayValue: 'Blockchain Information'
    }
};